<template>
  <div class="detail-tab-content">
    <div class="title">积分明细</div>
    <div class="content">
      <wt-form-table :key="4" :form.sync="form">
        <wt-form-table-list slot="wtFormTableList" :form.sync="form">
          <template slot="type" slot-scope="data">
            <span>{{ data.row.type === 10 ? data.row.remark : $wtConst.integralType[data.row.type] }}</span>
          </template>
          <template slot="integral" slot-scope="data">
            <span style="color: #F56C6C;" v-if="[8, 12, 16, 17, 21, 22, 23].indexOf(data.row.type) > -1">{{ '-' + data.row.integral }}</span>
            <span style="color: #67C23A;" v-else>{{ '+' + data.row.integral }}</span>
          </template>
        </wt-form-table-list>
      </wt-form-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralUserViewPointsDetail',
  isAutoComponent: true,
  props: ['id'],
  data() {
    return {
      form: {
        isFormLoading: false,
        formComponent: {
          list: { type: 'default', value: '/modules/userIntegralDetails/userIntegralDetailsList', params: { userId: 0 }}
        },
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '积分明细', key: 'type', type: 'custom' },
          { name: '时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '积分', key: 'integral', type: 'custom' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true, searchButtonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.userId = this.id
  }
}
</script>

<style>
</style>
